import Details from '@/components/Details/Details';
import ImgCalendarProvider from '@/components/ImgCalendarProvider';
import IBookingRules from '@/types/IBookingRules';
import {
	Accordion,
	AccordionButton,
	AccordionItem,
	AccordionPanel,
	Button,
	Checkbox,
	Flex,
	Grid,
	Heading,
	Text,
} from '@chakra-ui/react';
import AddCalendarModal from './components/add-calendar-modal/add-calendar-modal.view';
import { useSectionCalendars } from './section-calendars.controller';

export interface IProps {
	bookingRules: IBookingRules;
	onChange: (values: Partial<IBookingRules>) => void;
}

export default function SectionCalendars(props: IProps) {
	const { t, isLoading, groupedCalendars, handleCalendarClick, showModal, hideModal, isModalVisible } =
		useSectionCalendars(props);

	return (
		<Details title={t('Calendars')}>
			<AddCalendarModal close={hideModal} isOpen={isModalVisible} />

			<Text color="gray.700">
				{t(
					'Select the calendars where you want to check for conflicts. When you have events at certain time, the time slots will be blocked.'
				)}
			</Text>

			<Flex mt={4} justifyContent="flex-end">
				<Button size="xs" colorScheme="primary" onClick={showModal}>
					{t('Add calendar')}
				</Button>
			</Flex>

			<Accordion mt={4} allowMultiple defaultIndex={[0]}>
				{Object.keys(groupedCalendars)
					.sort((a, b) => a.localeCompare(b))
					.map((account) => {
						return (
							<AccordionItem key={account} mb={1} borderRadius="md" borderWidth={1} borderColor="gray.200">
								<AccordionButton py={4}>
									<Heading size="sm">{account}</Heading>
								</AccordionButton>
								<AccordionPanel pb={4}>
									<Accordion>
										{groupedCalendars[account].map((calendar) => {
											return (
												<Grid key={calendar.id} gridTemplateColumns="auto 1fr auto" alignItems="center">
													<ImgCalendarProvider size="4" provider={calendar.provider} />
													<Text fontStyle={calendar.primary ? 'none' : 'italic'} ml={2}>
														{calendar.name}
													</Text>
													<Checkbox
														isDisabled={isLoading}
														size="lg"
														isChecked={props.bookingRules.checkAvailabilityInCalendars.some(
															(c) => c.id === calendar.id
														)}
														onChange={(e) => handleCalendarClick(calendar.id, e.currentTarget.checked)}
													/>
												</Grid>
											);
										})}
									</Accordion>
								</AccordionPanel>
							</AccordionItem>
						);
					})}
			</Accordion>
		</Details>
	);
}
